export default "__VITE_ASSET__6AdOK6VG__"